export const footerLinkItems = [
  {
    title: 'Our Story',
    href: 'https://www.policygenius.com/about/',
  },
  {
    title: 'Values',
    href: 'https://www.policygenius.com/about/values/',
  },
  {
    title: 'Team',
    href: 'https://www.policygenius.com/about/team/',
  },
  {
    title: 'Careers',
    href: 'https://www.policygenius.com/careers/',
  },
  {
    title: 'Press',
    href: 'https://www.policygenius.com/about/press/',
  },
  {
    title: 'FAQ',
    href: 'https://www.policygenius.com/about/faq/',
  },
  {
    title: 'Partnerships',
    href: 'http://visit.policygenius.com/affiliate-partners/',
  },
];

export const legalLinkItems = [
  {
    title: 'Trust & Security',
    href: 'https://www.policygenius.com/about/trust/',
  },
  {
    title: 'Privacy Policy',
    href: 'https://www.policygenius.com/about/privacy/',
  },
  {
    title: 'Terms',
    href: 'https://www.policygenius.com/about/terms/',
  },
  {
    title: 'Licenses',
    href: 'https://www.policygenius.com/about/licenses/',
  },
];



// WEBPACK FOOTER //
// ../src/templates/Footer/data/links.js